import React, { Component } from 'react';
import {
    Redirect,
    Route,
    Link,
    Switch
} from 'react-router-dom';

import Article from './Article.js';
import './Guides.css';

const sectionedArticles = [
    {
        name: "Getting Started",
        articles: [
            {
                name: "Getting Started",
                id: "getting-started"
            },
            {
                name: "Introduction to gRPC",
                id: "introduction-to-grpc"
            },
            {
                name: "Authentication",
                id: "authentication"
            }
        ]
    },
    {
        name: "Advanced Topics",
        articles: [
            {
                name: "Working with IDs",
                id: "working-with-ids"
            },
            {
                name: "Understanding Template Outlines",
                id: "understanding-template-outlines"
            },
            {
                name: "Analyzing your Data",
                id: "analyzing-your-data"
            },
            {
                name: "REST API",
                id: "rest-api"
            }
        ]
    },
    {
        name: "Tutorials",
        articles: [
            {
                name: "Pull Data",
                id: "pull-data"
            },
            {
                name: "Schedule Inspections",
                id: "schedule-inspections"
            }
        ]
    }
]

class Guides extends Component {
    render() {
        return (
            <main role="main" class="container">
                <div class="row mt-5">
                    <div class="col-3">
                        {sectionedArticles.map((section) => (
                            <div>
                                <h5>{section.name}</h5>
                                <ul class="hpy-sidebar">
                                    {section.articles.map((article) => (
                                        <li>
                                            <Link to={`${this.props.match.url}/${article.id}`}>{article.name}</Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                    <div class="col-9">
                        <Switch>
                            <Route path={`${this.props.match.path}/:articleId`} component={Article}/>
                            <Route exact path={`${this.props.match.path}`} render={() => (
                                <Redirect to={`${this.props.match.path}/getting-started`} />
                            )}/>
                        </Switch>
                    </div>
                </div>
                <hr />
            </main>
        );
    }
}

export default Guides;



// WEBPACK FOOTER //
// ./src/Guides.js